var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDecreaseIndentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.18751 2.625C1.94588 2.625 1.75 2.82088 1.75 3.0625C1.75 3.30412 1.94588 3.5 2.18751 3.5H11.8128C12.0544 3.5 12.2503 3.30412 12.2503 3.0625C12.2503 2.82088 12.0544 2.625 11.8128 2.625H2.18751Z",
    fill: "#ABABAB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.56263 5.25C6.321 5.25 6.12512 5.44588 6.12512 5.6875C6.12512 5.92912 6.321 6.125 6.56263 6.125H11.8128C12.0544 6.125 12.2503 5.92912 12.2503 5.6875C12.2503 5.44588 12.0544 5.25 11.8128 5.25H6.56263Z",
    fill: "#ABABAB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.56263 7.875C6.321 7.875 6.12512 8.07088 6.12512 8.3125C6.12512 8.55412 6.321 8.75 6.56263 8.75H11.8128C12.0544 8.75 12.2503 8.55412 12.2503 8.3125C12.2503 8.07088 12.0544 7.875 11.8128 7.875H6.56263Z",
    fill: "#ABABAB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.18751 10.5C1.94588 10.5 1.75 10.6959 1.75 10.9375C1.75 11.1791 1.94588 11.375 2.18751 11.375H11.8128C12.0544 11.375 12.2503 11.1791 12.2503 10.9375C12.2503 10.6959 12.0544 10.5 11.8128 10.5H2.18751Z",
    fill: "#ABABAB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.0657 9.05936C4.23656 9.23021 4.51358 9.23021 4.68444 9.05936C4.8553 8.8885 4.8553 8.6115 4.68444 8.44064L3.24376 7L4.68444 5.55936C4.8553 5.3885 4.8553 5.1115 4.68444 4.94064C4.51358 4.76979 4.23656 4.76979 4.0657 4.94064L2.31566 6.69064C2.1448 6.86149 2.1448 7.1385 2.31566 7.30936L4.0657 9.05936Z",
    fill: "#ABABAB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDecreaseIndentIcon);
export default __webpack_public_path__ + "static/media/decreaseIndentIcon.506a59279bc12f1d82492aa30cbac8cb.svg";
export { ForwardRef as ReactComponent };